import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";

import TokenService from "services/TokenService";
import GoalService from "services/GoalService";
import RuleService from "services/RuleService";
import DonationService from "services/DonationService";
import AnimationService from "services/AnimationService";
import MainPage from "components/Admin/MainPage";
import { TOKEN } from "constants/index";
import useDonationsBlockState from "components/Admin/DonationsBlock/DonationsBlock.reducer";
import theme from "components/Admin/theme";

import "./Admin.scss";

export default function App() {
  const [tokens, setTokens] = useState();
  const [goals, setGoals] = useState([]);
  const [rules, setRules] = useState([]);
  const [animations, setAnimations] = useState([])
  const [donations, donationsHandlers] = useDonationsBlockState([]);
 
  useEffect(() => {
    async function getTokens() {
      if (TOKEN) {
        const tokens = await TokenService.getAll();
        setTokens(tokens);
      } else {
        setTokens(null);
      }
    }

    async function getGoals() {
      const goals = await GoalService.getAll();
      setGoals(goals);
    }

    async function getRules() {
      const rules = await RuleService.getAll();
      setRules(rules);
    }
    
    async function getDonations() {
      const donations = await DonationService.getAll();
      donationsHandlers.setAllDonations(donations);
    }

    async function getAnimations() {
      const animations = await AnimationService.getAll();
      setAnimations(animations);
    }

    async function loadAllData() {
      await getGoals();
      await getRules();
      await getDonations();
      await getTokens();
      await getAnimations();
    }

    loadAllData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errorPage = (<h1>Invalid token!</h1>);
  const checkPage = (<h1>Token verification...</h1>);
  
  const mainPageProps = { 
    tokens,
    setTokens,
    goals,
    setGoals,
    rules,
    setRules,
    donations,
    donationsHandlers,
    animations,
    setAnimations,
  };
  
  const pageToDisplay = tokens === undefined ? checkPage : tokens === null ? errorPage : (<MainPage { ...mainPageProps }/>);   

  return (
    <ThemeProvider theme={theme}>
      <div className="admin">
        {pageToDisplay}
      </div>
    </ThemeProvider>
  );
}
